import * as yup from 'yup';
import { FundingFrequencyTypesOptionsDTO } from '../../../../api/useAchFundingOptionsQuery';

export interface FormContext {
  isIraAccount: boolean;
}

export const depositFormValidation = yup.object().shape({
  account: yup
    .object()
    .nullable()
    .required('Please, select an account'),

  amount: yup.string().required('Please, enter an amount'),

  contributionTypesOptions: yup
    .object()
    .nullable()
    .when('$isIraAccount', (isIraAccount, schema) =>
      isIraAccount ? schema.required('Please, select a contribution type') : schema,
    ),

  contributionYearsOptions: yup
    .object()
    .nullable()
    .when('$isIraAccount', (isIraAccount, schema) =>
      isIraAccount ? schema.required('Please, select a contribution year') : schema,
    ),

  scheduledFundingFrequency: yup
    .object()
    .nullable()
    .required('Please, select a frequency for your deposit'),

  scheduledSecondDepositDate: yup
    .date()
    .nullable()
    .test(
      'greaterThanFirstDate',
      'Second date must occur after the first',
      // eslint-disable-next-line func-names
      function(value) {
        const {
          scheduledFundingFrequency,
          scheduledFirstDepositDate,
        }: {
          scheduledFundingFrequency: FundingFrequencyTypesOptionsDTO;
          scheduledFirstDepositDate: Date;
        } = this.parent;

        if (value && scheduledFundingFrequency?.showSecondRecurringDepositDay) {
          return value > scheduledFirstDepositDate;
        }

        return true;
      },
    ),
});
